import { useContext, useEffect, useState } from "react"
import AuthContext from "../../../contexts/Auth"
import InfiniteScroll from "../../atoms/InfiniteScroll"
import SearchIcon from "../../../assets/icons/SearchIcon"
import { Input as CoreInput } from "@stardust-ds/react"
import { fnFormatDateFromUTC } from "../../../utils/date"
import RcmpLoading from "../../atoms/Loading"
import intl from "react-intl-universal"
import styles from "./index.module.scss"
import Table from "../../atoms/Table"
import moment from "moment"
import useHistoric from "../../../hooks/useHistoric"

export default function RcmpHistory(props) {
  const {
    nTargetId,
    aHeaders,
    oGetHistory,
    fnFormatTextHistory,
    cException,
    cTargetHistoryType,
  } = props

  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone
  const [oParams, fnSetOParams] = useState({ cSearchTerm: "", nPage: 1 })
  const oConfigs = {
    target_nid: nTargetId,
    target_ctype: cTargetHistoryType,
  }
  const {
    fnGetListHistory,
    fnSearchHistory,
    aListHistory,
    aListHistoryData,
    fnSetListHistoryParams,
  } = useHistoric(oConfigs)
  async function fnGetActivityHistoryWithParams() {
    const nActivityId = nTargetId
    if (!nActivityId || aListHistoryData?.loading) return

    await fnGetListHistory()
  }

  useEffect(() => {
    ; (async () => {
      await fnGetActivityHistoryWithParams()
    })()
  }, [oParams])

  function fnNextPage(nPage) {
    fnSetListHistoryParams((prevParams) => ({ ...prevParams, page: nPage }))
  }

  function fnHandleSearchHistory(e) {
    const cSearchTerm = e?.target?.value
    fnSearchHistory(cSearchTerm)
  }

  return (
    <div className={styles.historyContainer}>
      <div className={styles.searchArea}>
        <CoreInput
          isFullWidth
          height={64}
          bColor={"#fff"}
          className={styles.inputSearch}
          placeholder={intl.get("ActivityHistory.search_history")}
          onChange={fnHandleSearchHistory}
          iconLeft={<SearchIcon />}
        />
      </div>
      <InfiniteScroll
        fnNext={fnNextPage}
        nTotalPages={aListHistoryData?.data?.data?.last_page}
        nDataLength={aListHistory?.length}
        bStopPagination={aListHistoryData?.error || aListHistoryData?.loading}
        scrollableTarget="history-overflow-content"
      >
        <div id="history-overflow-content" className={styles.tableContainer}>
          <Table bHideArrow={true}>
            <Table.THead className={styles.tableHead}>
              <Table.TRow className={styles.tableHead}>
                {aHeaders.map((cHeader, nIndex) => (
                  <Table.HeadData key={nIndex}>{cHeader}</Table.HeadData>
                ))}
              </Table.TRow>
            </Table.THead>
            <Table.TBody className={styles.tBodyContainer}>
              {aListHistory?.map((oHistory) => {
                const result = fnFormatTextHistory(oHistory, oHistory.opht_caction)
                const cActionText = (() => {
                  switch (oHistory.opht_caction) {
                    case "update":
                      if (oHistory.opht_cfield === "opa_notf_nid" && oHistory.opht_cnew_value !== null) return intl.get("modal_automation_list.history.stopped");
                      if (oHistory.opht_cfield === "opa_notf_nid" && !oHistory.opht_cnew_value) return intl.get("modal_automation_list.history.returned");
                      return intl.get("modal_automation_list.history.update");
                    case "created":
                      return intl.get("modal_automation_list.history.create");
                    case "deleted":
                      return intl.get("modal_automation_list.history.deleted");
                    default:
                      return "";
                  }
                })();
                if (result !== undefined) {
                  return (
                    <Table.TRow key={oHistory?.opah_nid}>
                      <Table.TData style={{ minWidth: 110 }}>
                        {fnFormatDateFromUTC(
                          oHistory.opht_dcreated,
                          "DD/MM/YYYY - HH:mm",
                          cUserTimeZone,
                        )}
                      </Table.TData>
                      <Table.TData className={styles.userNameArea}>
                        {oHistory?.opht_user?.cname}
                      </Table.TData>
                      <Table.TData>
                        {cActionText}
                      </Table.TData>
                      <Table.TData> {result}</Table.TData>
                    </Table.TRow>
                  )
                }
              })}
            </Table.TBody>
          </Table>
        </div>
      </InfiniteScroll>
      <RcmpLoading bShow={aListHistoryData?.loading} size={50} />
    </div>
  )
}
